import { config } from './config';
import { tokens } from './tokens';
import axios from 'axios';
import { handleAxiosError } from './utils/error.utils';
import { UnexpectedAPIError } from './errors';
export const email = (() => {
    async function request(email) {
        try {
            const url = `${baseUrl()}/request`;
            const data = { email };
            const response = await axios.put(url, data);
            if (response.status === 200) {
                return;
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function confirm(token) {
        try {
            // start with clean axios, no interceptors
            const _axios = axios.create();
            const url = `${baseUrl()}/confirm`;
            const data = undefined;
            const requestConfig = { headers: { Authorization: `Bearer ${token}` } };
            const response = await _axios.post(url, data, requestConfig);
            if (response.status === 200) {
                return tokens.set(response.headers);
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/email`;
    }
    return {
        request: request,
        confirm: confirm,
    };
})();
